import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations } from '../../content/siteContentUtils';

const fallbackAchievements = [
    {
        title: 'Marka Kuruluşu',
        description: 'Fırat Çelik Kapı üretim faaliyetlerine kalite ve güvenlik odaklı bir vizyonla başladı.',
        date: '01', month: 'Eki', year: '2013'
    },
    {
        title: 'Üretim Kapasitesi Artışı',
        description: 'Artan talebe cevap verebilmek için üretim hattı ve operasyon süreçleri güçlendirildi.',
        date: '20', month: 'Mar', year: '2014'
    },
    {
        title: 'Yeni Ürün Serileri',
        description: 'Modern ve klasik çelik kapı modelleri ürün gamına eklenerek seçenekler artırıldı.',
        date: '28', month: 'Ağu', year: '2014'
    },
    {
        title: 'Kurumsal Proje Teslimleri',
        description: 'Yüksek adetli projelerde standartlara uygun ve zamanında teslim süreçleri başarıyla tamamlandı.',
        date: '20', month: 'Eki', year: '2015'
    },
    {
        title: 'Bölgesel Büyüme',
        description: 'Bayi ve müşteri ağı genişletilerek daha fazla noktaya hizmet sunulmaya başlandı.',
        date: '27', month: 'Kas', year: '2015'
    },
    {
        title: 'Müşteri Deneyimi Güçlendirme',
        description: 'Satış öncesi ve sonrası destek süreçleri iyileştirilerek müşteri memnuniyeti artırıldı.',
        date: '07', month: 'Mar', year: '2016'
    },
    {
        title: 'Tasarım ve Ar-Ge Gelişimi',
        description: 'Özel ölçü ve dekoratif çözümler için tasarım kabiliyeti geliştirilerek yeni seçenekler sunuldu.',
        date: '19', month: 'Tem', year: '2017'
    },
    {
        title: 'Sürdürülebilir Kalite Standardı',
        description: 'Üretim ve montaj süreçlerinde kalite standardı korunarak istikrarlı hizmet yapısı sağlandı.',
        date: '27', month: 'May', year: '2018'
    }
];

var bgimg1 = require('./../../images/background/bg-map.png');
var bgimg2 = require('./../../images/background/cross-line2.png');

class Achievements1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const section = t?.pages?.about?.achievements || {};
        const incomingItems = Array.isArray(section.items) ? section.items : [];
        const items = fallbackAchievements.map((fallback, index) => ({ ...fallback, ...(incomingItems[index] || {}) }));
        const leftItems = items.slice(0, 4);
        const rightItems = items.slice(4, 8);

        const renderStory = (item, index) => (
            <div className="sx-box our-story achievements-showcase-card text-white" key={index}>
                <div className="mt-media our-story-info d-flex justify-content-start">
                    <div className="our-story-time"><span className="date">{item.date}</span><span className="month">{item.month}</span></div>
                    <h4 className="text-uppercase our-story-year achievements-showcase-year">{item.year}</h4>
                </div>
                <div className="our-story-detail">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                </div>
            </div>
        );

        return (
            <>
                <div className="section-full p-t80 p-b50 bg-no-repeat bg-bottom-center mobile-page-padding achievements-showcase" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container">
                        <div className="section-head">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                    <h3 className="sep-line-one">{section.title || 'Başarılarımız'}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 m-b30">
                                    {leftItems.map((item, index) => renderStory(item, index))}
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12">
                                    {rightItems.map((item, index) => renderStory(item, index + 4))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Achievements1;